<template>
  <b-container>
    <div v-if="showoverlay" style="z-index: 999; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
      <b-spinner style="width: 3rem; height: 3rem;" label="Please wait..."></b-spinner>
    </div>
    <b-overlay class="overspin" :show="showoverlay" rounded="sm" fixed>
      <b-row>
        <b-col  class="mt-4">
          <h4 style="text-align: center;">Categories</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-list-group >
            <b-row class="mt-3 mb-3">
              <b-col cols='11'>
                <b-list-group-item class="items-warpper">
                  <b-row>
                    <!-- <b-col cols="1">
                      <a :href="'#'+$route.path"><b-icon icon="plus-circle" variant="primary" font-scale="2.5" v-b-popover.hover.left="'Add new Category'" @click="addCategory()"></b-icon></a>
                    </b-col> -->
                    <b-col cols="12">
                      <b-form-input v-model="newcatname" placeholder="Add new Category"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="10"><b-alert v-if="newcatalert" variant="info" v-model="newcatalert" dismissible>Please enter a Category name!</b-alert></b-col>
                  </b-row>
                </b-list-group-item>
              </b-col>
              <b-col cols='1'>
                <b-button class='add-btn' variant="outline-dark" @click="addCategory()">+</b-button>
              </b-col>
            </b-row>
            <draggable v-model="categories" @end="dragend" handle=".handle">
              <CategoryList
                v-for="category of categories"
                v-bind:category="category"
                v-bind:key="category.id"
                @emit-fetch-categories="fetchMenuCategories"
                @emit-switch-overlay="switchOverlay">
              </CategoryList>
            </draggable>
          </b-list-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination v-model="currentPage" :total-rows="total_categories" :per-page="limit" align="center" @change="showoverlay=true; fetchMenuCategories()"></b-pagination>
          <p style="text-align: center;">Total categories: {{ total_categories }}</p>
        </b-col>
      </b-row>
    </b-overlay>
  </b-container>
</template>

<script>
import CategoryList from '@/components/CategoryList.vue'
import draggable from 'vuedraggable';
export default {
  name: "MenuCategories",
  components: {
    CategoryList,
    draggable
  },
  data() {
    return {
      categories: [],
      total_categories: 0,
      limit: 25,
      currentPage: 1,
      showoverlay: false,
      newcatname: '',
      newcatalert: false
    };
  },

  computed: {
    // all pagination, filtering and sorting info collected here for housekeeping purposes
    urlext: function() {
      return "?page="+this.currentPage+"&limit="+this.limit;
    }
  },

  methods: {
    dragend() {
      var cats = [];
      var i=1;
      for (const cat of this.categories) {
        cats.push({
          "category_id": cat.id,
          "sort_order": i
        });
        i+=1;
      }
      cats = {"cats_sort": cats}
      this.updateCatSort(cats);
    },

    switchOverlay(bool) {
      this.showoverlay = bool;
    },

    async addCategory() {
      if (this.newcatname == '') {
        this.newcatalert = true;
        return;
      }
      this.showoverlay=true;
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        "name": this.newcatname
      }
      // update order with status of 'ready'
      const { data } = await this.$api.post('categories',
        body,
        config
      );
      if (data.created == true) {
        this.newcatname = '';
        this.fetchMenuCategories();
      } else {
        this.showoverlay=false;
        this.$bvModal.msgBoxOk('There was a problem adding the category, please try again later.', {
          title: 'Error adding category',
          centered: true
        })
      }
    },

    async fetchMenuCategories() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("categories"+this.urlext, {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      try {
        this.categories = await data.categories;
        this.total_categories = data.total_categories;
        this.showoverlay = false;
      } catch(e) {
        console.log(e);
        this.showoverlay = false;
      }
    },

    async updateCatSort(cats) {
      this.switchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = cats;
      // update order with status of 'ready'
      const { data } = await this.$api.patch('categories/sortorder',
        body,
        config
      );
      if (data.success == true) {
        this.switchOverlay(false);
      } else {
        this.switchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem updating the sort order, please try again later.', {
          title: 'Error updating sort order',
          centered: true
        })
      }
    },

  },

  created: function() {
    // this.showoverlay = true;
    this.fetchMenuCategories();
  }
}
</script>
<style >
 .items-warpper{
    border: none;
    padding: 0px;
    margin:10px inherit;
    width:inherit;
  }
  .items-warpper .form-control{
    outline: none;
    border: none;
    padding :26px;
    width:100%;
  }
  .items-warpper .form-control:focus{
    box-shadow: 0 2px 6px rgb(84 70 35 / 15%), 0 1px 3px rgb(84 70 35 / 15%); 
   }
   .add-btn{
     font-size: 2rem;
     border: none;
     color:gray

   }
   .add-btn:hover{
     background: none;
     color:black ;
     transform: scaleZ(2);
   }
  .add-btn:focus{
    outline: none;
    box-shadow: none;
    border-inline:none ;
    border:none;
    background: none;
  }
</style>

